import { Component } from '@theme/component';

/**
 * A custom element that renders a video background.
 *
 * @typedef {object} Refs
 * @property {HTMLElement[]} videoSources - The video sources.
 * @property {HTMLVideoElement} videoElement - The video element.
 *
 * @extends Component<Refs>
 */
export class VideoBackgroundComponent extends Component {
  requiredRefs = ['videoSources', 'videoElement', 'playButton'];

  connectedCallback() {
    super.connectedCallback();

    const { videoSources, videoElement, playButton } = this.refs;

    for (const source of videoSources) {
      const { videoSource } = source.dataset;

      if (videoSource) source.setAttribute('src', videoSource);
    }

    videoElement.load();

    playButton?.addEventListener('click', this.handleClick.bind(this))
  }

  handleClick() {
    const { playButton, videoElement } = this.refs;
    const isVideoPlaying = !!(videoElement.currentTime > 0 && !videoElement.paused && !videoElement.ended && videoElement.readyState > 2);
    console.log(isVideoPlaying)

    if (isVideoPlaying) {
      videoElement.pause()
      playButton.classList.add('paused')
      playButton.classList.remove('playing')
    } else {
      videoElement.play()
      playButton.classList.add('playing')
      playButton.classList.remove('paused')
    }
  }
}

if (!customElements.get('video-background-component')) {
  customElements.define('video-background-component', VideoBackgroundComponent);
}
